import { isDefined } from '@utils/isDefined';
import { type Maybe } from './Maybe';

export function withFallback(
    value?: Maybe<string>,
    customFallback?: string,
): string {
    if (!isDefined(value)) {
        return customFallback ?? '-';
    }

    return isDefined(value) ? value : '';
}
